<template>
  <v-card class="vacancyDetailCard" >
    <div v-if="chatOptions?.length || phoneNumbers?.length">

        <div v-if="chatOptions?.length">
          <v-card-title>{{ computedChatTitle }}</v-card-title>
          <v-card-text v-for="chat in chatOptions" :key="chat.label" class="py-0">
            <a class="no-link-style" :href="chat.url">
              <v-icon class="me-1">{{ chat.icon }}</v-icon>
              <span>{{ chat.label }}</span>
            </a>
          </v-card-text>
        </div>
        
        <div v-if="phoneNumbers?.length">
          <v-card-title>{{ computedPhoneTitle }}</v-card-title>
          <v-card-text v-for="phone in phoneNumbers" :key="phone.number" class="py-0">
            <a class=" no-link-style" :href="`tel:${phone.number}`">
              <v-icon class="me-1">mdi-phone</v-icon>
              <span>{{ phone.display }}</span>
            </a>
          </v-card-text>
        </div>
      </div>
        <div v-if="emailAddresses?.length">
          <v-card-title>{{ computedEmailTitle }}</v-card-title>
          <v-card-text v-for="email in emailAddresses" :key="email.address" class="py-0">
            <a class=" no-link-style" :href="`mailto:${email.address}`">
              <v-icon class="me-1">mdi-email</v-icon>
              <span>{{ email.display || email.address }}</span>
            </a>
          </v-card-text>
        </div>
    
    <div v-if="emailAddresses?.length && !chatOptions?.length && !phoneNumbers?.length" >
      <v-card-title>{{ computedEmailTitle }}</v-card-title>
      <v-card-text v-for="email in emailAddresses" :key="email.address" class="py-0">
        <a class=" no-link-style" :href="`mailto:${email.address}`">
          <v-icon class="me-1">mdi-email</v-icon>
          <span>{{ email.display || email.address }}</span>
        </a>
      </v-card-text>
    </div>

    <div v-if="visitInfo">
      <v-card-title>{{ computedVisitTitle }}</v-card-title>
      <v-card-text>
      <a class=" no-link-style mb-3" v-if="visitInfo.mapUrl" :href="visitInfo.mapUrl">
        <v-icon class="me-1">mdi-map-marker</v-icon>
        <span>{{ visitInfo.address }}</span>
      </a>
      <a class=" no-link-style mb-3" v-else>
        <v-icon class="me-1">mdi-map-marker</v-icon>
        <span>{{ visitInfo.address }}</span>
      </a>
    </v-card-text>
    </div>
    
    <div v-if="openingHours">
      <v-card-title>{{ computedHoursTitle }}</v-card-title>
      <v-card-text>
      <v-icon class="me-1">mdi-clock-time-five-outline</v-icon>
      <span>{{ openingHours }}</span>
      </v-card-text>
    </div>


  </v-card>
</template>

<script>
export default {
  props: {
    chatTitle: {
      type: String,
      default: null
    },
    chatOptions: {
      type: Array,
      default: () => []
    },
    phoneTitle: {
      type: String,
      default: null
    },
    phoneNumbers: {
      type: Array,
      default: () => []
    },
    emailTitle: {
      type: String,
      default: null
    },
    emailAddresses: {
      type: Array,
      default: () => []
    },
    visitTitle: {
      type: String,
      default: null
    },
    visitInfo: {
      type: Object,
      default: null
    },
    hoursTitle: {
      type: String,
      default: null
    },
    openingHours: {
      type: String,
      default: null
    }
  },
  computed: {
    computedChatTitle() {
      return this.chatTitle || this.$t('vacancies.contact.chat', 'Chatten')
    },
    computedPhoneTitle() {
      return this.phoneTitle || this.$t('vacancies.contact.phone', 'Bel ons')
    },
    computedEmailTitle() {
      return this.emailTitle || this.$t('vacancies.contact.email', 'Mail ons')
    },
    computedVisitTitle() {
      return this.visitTitle || this.$t('vacancies.contact.visit', 'Bezoek ons')
    },
    computedHoursTitle() {
      return this.hoursTitle || this.$t('vacancies.contact.hours', 'Openingstijden')
    }
  }
}
</script>
